import {MoreAboutInstaller} from './common/MoreAboutInstaller';

export class Installer {
  id: number;
  signatureapplicationId: number;
  description: string;
  originalName: string;
  version: string;
  extension: string;
  hash: string;
  typefile: number;
  createAt: string;
  active: number | any;
  updatedVersionMessage: string;
  newVersionMessage: string;
  // tslint:disable-next-line:variable-name
  _more: MoreAboutInstaller;
}
